import rsvpBulkMessageModalCreator from '../../../../../modules/messages/helpers/rsvp-bulk-message-modal-creator';

angular
    .module('festzelt-os.guestlists')
    .factory('bulkUpdateRsvpStatus', [
        '$injector',
        ($injector) => new BulkUpdateRsvpStatus($injector)
    ]);

class BulkUpdateRsvpStatus {
    constructor($injector) {
        this.injector = $injector;
        this.state = this.injector.get('$state');
        this.resourceSelect = this.injector.get('ResourceSelect');
        this.alert = this.injector.get('Alert');
        this.api = this.injector.get('$http');
        this.rsvpsStore = this.injector.get('Rsvps');
        this.guestlist = null;

        this.key = 'bulk-update-rsvp';
        this.title = 'Update Status';
        this.level = 'selected';
    }

    action(action, store) {
        this.resourceSelect.selectStatus().then((result) => {
            this.updateGuestlistData(store).then(() => {
                console.log(this.guestlist);
                const selectedStatus = result.selectedStatus;

                if (store.state.selection.selectAll) {
                    let tablePaginationPerPage = store.state.pagination.perPage;
                    let tablePaginationPages = store.state.pagination.pages;
                    let rsvpBulkUrl = `fp/rsvps`;

                    if (this.guestlist) {
                        rsvpBulkUrl = `fp/guestlists/${store.state.permanentFilters.guestlist_id}/rsvps`;
                    }
                    this.api.post(rsvpBulkUrl, this.setupRsvpsPayload(store)).then((response) => {
                        if (tablePaginationPerPage) {
                            store.state.pagination.perPage = tablePaginationPerPage
                        }
                        if (tablePaginationPerPage) {
                            store.state.pagination.pages = tablePaginationPages
                        }
                        this.updateRsvpStatus(selectedStatus, response.data.data, store, tablePaginationPerPage, tablePaginationPages);
                    });
                } else {
                    this.updateRsvpStatus(selectedStatus, store.getters.selectedRows, store)
                }
            });
        }, () => {
        });
    }

    updateRsvpStatus(selectedStatus, selectedRsvps, store) {
        this.api.put(`rsvps`, {
            fields: {
                rsvp: {
                    status: selectedStatus
                }
            },
            items: store.getters.selectedFilters
        }).then(() => {
            this.alert.success('Bookings Update', 'The status of the given rsvps has been updated');
            store.dispatch('getData');
            store.commit('setRefresh', true);

            let changedStatusRsvps = [];
            selectedRsvps.forEach(function (rsvp) {
                if (rsvp.status === selectedStatus) {
                    store.state.selection.selectedRows[rsvp.id] = false
                } else {
                    changedStatusRsvps.push(rsvp.id);
                }
            });

            store.state.pagination.toatal = changedStatusRsvps.length;
            if (this.existEmailTemplateForStatus(selectedStatus) && changedStatusRsvps.length > 0) {
                const newRsvpsStore = this.rsvpsStore.create('BulkUpdateStatusMessageStore')

                newRsvpsStore.dispatch('getDefinitions')
                    .then(() => {
                        newRsvpsStore.commit('setFilters', {
                            id: changedStatusRsvps.join(' OR ')
                        })

                        newRsvpsStore.dispatch('getData')
                            .then(() => {
                                newRsvpsStore.commit('setSelectAll', true)
                                this.alert.confirm({
                                    title: '',
                                    message: 'Do you want to send a ' + this.formatEmailType(selectedStatus) + ' email to ' + changedStatusRsvps.length + ' rsvps ?',
                                    confirmBtn: 'Send'
                                }).then(() => {
                                    rsvpBulkMessageModalCreator(
                                        this.injector,
                                        newRsvpsStore,
                                        this.guestlist,
                                        {
                                            preSelectedTemplateId: this.getStatusTemplateIdForGuestlist(selectedStatus),
                                            recipientIdsOverride: changedStatusRsvps
                                        }
                                    );
                                }, () => {
                                })
                            })
                    })
            }
        }, err => {
            this.alert.handle(err);
        });
    }

    setupRsvpsPayload(store) {
        let pagination = store.state.pagination;
        pagination.perPage = pagination.total;

        return {
            keyword: store.state.keyword,
            filters: store.getters.selectedFilters.filters,
            fields: ['id', 'status'],
            onlyArchived: false,
            pagination: pagination
        }
    }

    updateGuestlistData(store) {
        return new Promise((resolve, reject) => {
            if (store.state.permanentFilters.guestlist_id) {
                this.api.get(`guestlists/${store.state.permanentFilters.guestlist_id}`).then((response) => {
                    this.guestlist = response.data.data;
                    resolve();
                }, (e) => {
                })
            } else {
                resolve();
            }
        })
    }

    formatEmailType(selectedRsvpStatus) {
        let formattedEmailType = selectedRsvpStatus.substring(0, selectedRsvpStatus.length - 2) + 'ation';
        if (selectedRsvpStatus === 'waitlisted' || selectedRsvpStatus === 'requested') {
            formattedEmailType = selectedRsvpStatus.substring(0, selectedRsvpStatus.length - 2);
        } else if (selectedRsvpStatus === 'declined') {
            formattedEmailType = 'decline';
        }

        return formattedEmailType.charAt(0).toUpperCase() + formattedEmailType.slice(1);
    }

    existEmailTemplateForStatus(selectedRsvpStatus) {
        return !_.isNull(this.getStatusTemplateIdForGuestlist(selectedRsvpStatus));
    }

    getStatusTemplateIdForGuestlist(status) {
        if (!this.guestlist) {
            return null;
        }
        const filteredGuestlistTemplates = _.filter(this.guestlist.templates, template => (template.status === status));

        if (filteredGuestlistTemplates.length > 0) {
            return _.get(_.first(filteredGuestlistTemplates), 'template_id', null);
        }

        return null;
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/workflows/general/rsvps-list/update-status.js